<p-toast position="bottom-right"></p-toast>

<div class="card-white">
    <!-- Header con título y botones -->
    <div class="card-header mb-4">
        <div class="title-section">
            <h2 class="header-title">Parámetros Generales</h2>
        </div>
        <div class="button-section">
            <button mat-flat-button class="btn-success" (click)="aceptar()" [disabled]="loading">
                <mat-icon>check</mat-icon>
                Aceptar
            </button>
            <button mat-flat-button class="btn-delete" (click)="borrar()" [disabled]="loading"
                *ngIf="tieneDatos">
                <mat-icon>delete</mat-icon>
                Borrar
            </button>
            <button mat-flat-button class="btn-search" (click)="openCustomizables()" [disabled]="loading"
                *ngIf="tieneDatos">
                <mat-icon>tune</mat-icon>
                Customizables
            </button>
        </div>
    </div>

    <!-- Formulario -->
    <form [formGroup]="form" class="form-container">
        <div class="form-row">
            <div class="form-field flex-grow-1">
                <input pInputText type="text" formControlName="nombreCliente" class="form-control"
                    placeholder="Ingrese nombre del cliente">
                <label>Nombre Cliente</label>
            </div>
            <div class="form-field flex-grow-1">
                <input pInputText type="text" formControlName="ciudad" class="form-control"
                    placeholder="Ingrese ciudad">
                <label>Ciudad</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field flex-grow-1">
                <p-dropdown formControlName="claveEstado" [options]="estadosOpciones" optionLabel="sOpcion"
                    optionValue="value" placeholder="Seleccione estado"></p-dropdown>
                <label>Clave Estado</label>
            </div>
            <div class="form-field flex-grow-1">
                <p-dropdown formControlName="pais" [options]="paisesOpciones" optionLabel="sOpcion"
                    optionValue="value" placeholder="Seleccione país"></p-dropdown>
                <label>País</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field flex-grow-1">
                <input pInputText type="text" formControlName="nacionalidad" class="form-control"
                    placeholder="Ingrese nacionalidad">
                <label>Nacionalidad</label>
            </div>
            <div class="form-field flex-grow-1">
                <p-dropdown formControlName="moneda" [options]="monedasOpciones" optionLabel="sOpcion"
                    optionValue="value" placeholder="Seleccione moneda"></p-dropdown>
                <label>Moneda</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field flex-grow-1">
                <input pInputText type="date" formControlName="fechaSistema" class="form-control" [disabled]="true">
                <label>Fecha Sistema</label>
            </div>
        </div>
        <div class="checkbox-field">
            <input type="checkbox" formControlName="haciendoCierre">
            <label>Haciendo Cierre</label>
        </div>
    </form>
</div>